import { render, staticRenderFns } from "./TaskCardProject.vue?vue&type=template&id=8b730e20"
import script from "./TaskCardProject.vue?vue&type=script&lang=js"
export * from "./TaskCardProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports